import { Button } from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

interface DetailsCardButtonProps {
  onClick?: () => void;
};

const DetailsCardButton: React.FC<DetailsCardButtonProps>= (props: DetailsCardButtonProps) => {
  return (
    <Button
      onClick={props.onClick}
      variant="outlined"
      startIcon={<InsertDriveFileOutlinedIcon sx={{ fontSize: "9px !important" }}/>}
      sx={{
        width: "97px",
        height: "15px",
        border: "1px solid #0A0C33",
        borderRadius: "10px",
        color: "#0A0C33",
        fontSize: "0.75rem",
        textTransform: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4px",
        minWidth: "auto",
        marginLeft: "10px",
        fontWeight: "bold",
      }}
    >
      Detalhes
    </Button>
  );
};

export default DetailsCardButton;
